module.exports = {"footer-powered-by":"2018 Sri Krishna Premamrutham Trust","hello-essential-links":"Essential Links","hello-ecosystems":"Ecosystem","navbar-title":"Sri Krishna Premamruthan Trust"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/en.json
// module id = yF0G
// module chunks = 1